<template>
  <div>
    <div class="text-center m-0 d-flex mt-5">
      <!-- Video element to show the CCTV feed -->
      <video
        ref="video"
        :src="cctvFeedUrl"
        style="max-width:1000px; border-radius: 16px; border: 10px solid #fff; background: rgba(255, 255, 255, 0.90);"
        height="500px"
        autoplay
        muted
      ></video>

      <!-- Image element to display the processed frame -->
      <img
        ref="processedFrame"
        :src="processedFrameSrc"
        alt="Processed frame will appear here"
        style="max-width:1000px; border-radius: 16px; border: 10px solid #fff; background: rgba(255, 255, 255, 0.90);"
        height="500px"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "YoloV8ObjectDetection",
  data() {
    return {
      cctvFeedUrl: "rtsp://admin123:password123@202.184.65.40:554/stream1", // Replace with your CCTV feed URL
      processedFrameSrc: "data:image/jpeg;base64,", // Initial empty image source
    };
  },
  mounted() {
    // Send frames at a set interval (every 200ms)
    this.frameInterval = setInterval(this.sendFrame, 200);
  },
  beforeDestroy() {
    clearInterval(this.frameInterval);
  },
  methods: {
    // Capture a frame from the video feed and send it to the server for processing
    sendFrame() {
      const video = this.$refs.video;

      // Only proceed if the video is playing
      if (video.paused || video.ended) return;

      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const context = canvas.getContext("2d");
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(
        (blob) => {
          const formData = new FormData();
          formData.append("file", blob, "frame.jpg");

          // Send the frame to the server
          fetch("https://cellnet.mywire.org" + "/idx_process_frame", {
            method: "POST",
            body: formData,
          })
            .then((response) => response.blob())
            .then((blob) => {
              const url = URL.createObjectURL(blob);
              this.processedFrameSrc = url; // Update the processed image source
            })
            .catch((error) => {
              console.error("Error sending frame:", error);
            });
        },
        "image/jpeg"
      );
    },
  },
};
</script>

<style scoped>
/* Custom styles */
h1 {
  text-align: center;
  margin-top: 20px;
}

video {
  display: block;
  margin: 20px auto;
}

img {
  display: block;
  margin: 20px auto;
  max-width: 100%;
}
</style>